import React, { useState } from "react";
import DupontCheckbox from "components/DupontCheckbox";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  checkboxContainer: { display: "inline-block", verticalAlign: "middle" }
}));

const InsightsListCheckboxRenderer = props => {
  const classes = useStyles();
  const { field } = props;
  const [isChecked, setIsChecked] = useState(props.node.data[field]);

  const selectionChangeHandler = val => {
    const { data } = props.node;
    data[field] = val;
    props.node.setData(data);
    props.context.onInsightsUpdate({ Id: data.Id, [field]: val });
  };

  return (
    <span className={classes.checkboxContainer}>
      <DupontCheckbox checked={isChecked} onChange={selectionChangeHandler} />
    </span>
  );
};

export default InsightsListCheckboxRenderer;
